import { apiRequest } from '@/lib/api-client';

export interface SalesConfig {
  webhookUrl: string;
  secret: string;
}

export interface SalesOverview {
  orderCount: number;
  revenue: number;
  recent: Array<{ externalId: string; amount: number; currency: string; occurredAt: string }>;
}

const base = (orgId: string, projectId: string) =>
  `/api/v1/organizations/${orgId}/projects/${projectId}/sales`;

export const salesApi = {
  overview: (orgId: string, projectId: string) =>
    apiRequest<SalesOverview>(`${base(orgId, projectId)}/overview`),
  getConfig: (orgId: string, projectId: string) =>
    apiRequest<SalesConfig>(`${base(orgId, projectId)}/config`),
  rotate: (orgId: string, projectId: string) =>
    apiRequest<SalesConfig>(`${base(orgId, projectId)}/config/rotate`, { method: 'POST' }),
};
